<template>
  <div>
    <div class="animated fadeIn step-container">
    
      <div class="row">

        <div class="col-md-8 offset-md-2">
          <h2 v-if="$route.query.action === 'edit'">{{$t('message.doctor_header.title_edit')}}</h2>
          <h2 v-else>{{$t('message.doctor_header.title_new')}}</h2>
          <step :currentStep="5" :maxStep="5" @step_clicked='gotoPage'>
            <div slot='1'>{{$t('message.doctor_header.personal_info')}}</div>
            <div slot='2'>{{$t('message.doctor_header.experience')}}</div>
            <div slot='3'>{{$t('message.doctor_header.schedules')}}</div>
            <div slot='4'>{{$t('message.doctor_header.education')}}</div>
            <div slot='5'>{{$t('message.doctor_header.other_info')}}</div>
          </step>
        </div>

        <div class="col-md-8 offset-md-2 step-body">
          <h4 class="step-header">{{$t('message.doctor_header.other_info')}}</h4>

          <div class="row">
            <div class="col-12">
              <h6>{{$t('message.doctor_info.language')}}</h6>
            </div>

            <div class="col-12">
              <div class="form-group">
                <multiselect id="languages" 
                      class="multi-select-form"
                      v-model="selected_languages" 
                      :placeholder="$t('message.doctor_info.language_placeholder')" 
                      :options="language_list" 
                      :multiple="true"
                      :hide-selected="true"
                      :allow-empty="true" 
                      selected-label="" 
                      select-label="" 
                      deselect-label=""
                      label="label" 
                      track-by="label"></multiselect>
              </div>
            </div>
          </div>

          <div class="form-divider"></div>

          <!-- Video -->
          <div class="row">
            <div class="col-12">
              <h6>{{$t('message.doctor_info.video_links')}}</h6>
            </div>
            <div class="col-12">
              <p class="step-subheader">{{$t('message.doctor_info.youtube_link')}}</p>
            </div>
          </div>

          <doctor-array-input :dataset.sync="doctor.th.video_links"
                              @update:dataset="v => doctor.th.video_links = v"
                              :description="$t('message.doctor_info.youtube_link')" />

          <div class="form-divider"></div>

          <!-- More info -->
          <div class="row">
            <div class="col-12" v-on:click="checkFeature()">
              <h6>{{$t('message.doctor_info.addition_info')}} <i aria-hidden="true" class="fa fa-lock menu-lock" v-if="!isActive"></i></h6>
            </div>

            <div class="col-12" v-on:click="checkFeature()">
              <p class="step-subheader">{{$t('message.doctor_info.addition_info_th')}} </p>
            </div>

            <div class="col-12" v-on:click="checkFeature()">
              <ckeditor v-model="doctor.th.info" :config="ckeditorConfig"/>
              <div class="editor-lock"><i aria-hidden="true" class="fa fa-lock menu-lock" v-if="!isActive"></i></div>
            </div>

            <div class="col-12" v-on:click="checkFeature()">
              <p class="step-subheader">{{$t('message.doctor_info.addition_info_en')}}</p>
            </div>

            <div class="col-12" v-on:click="checkFeature()">
              <ckeditor v-model="doctor.en.info" :config="ckeditorConfig"/>
              <div class="editor-lock"><i aria-hidden="true" class="fa fa-lock menu-lock" v-if="!isActive"></i></div>
            </div>

          </div>

          <div class="row">
            <div class="col-12 form-group">
              <button class="btn btn-cancel btn-lg" @click="back">{{$t('action_message.back')}}</button>
              <button class="btn btn-store btn-lg" @click="saveAndContinue">{{$t('action_message.save')}}</button>
              <button v-if="$route.query.action === 'edit'" class="btn btn-delete btn-right btn-lg" @click="deleteDoctor">{{$t('action_message.remove')}}</button>
            </div>
          </div>

        </div>
    </div>

      <sweet-modal icon="success" ref="modal">
        <h2 v-if="editMode">{{$t('message.doctor_info.save_success')}}</h2>
        <h2 v-else>{{$t('message.doctor_info.create_success')}}</h2>
      </sweet-modal>

      <sweet-modal icon="info" title="ฟังชั้นนี้ถูกปิดการใช้งานอยู่" ref="infoLockModal" overlay-theme="dark">
        <p>ฟังชั้นนี้ถูกปิดการใช้งานอยู่ ต้องการปลดล๊อกกรุณากดปุ่ม unlock ด้านล่าง</p>
        <button v-on:click="gotoPlanPage()" class="btn btn-add btn-lg btn-success"><i class="fa fa-key" aria-hidden="true" v-if="!isActive"></i> Unlock</button>
      </sweet-modal>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import Step from '@/components/StepBar'
import DoctorArrayInput from '@/components/DoctorArrayInput'
import Multiselect from 'vue-multiselect'
import Ckeditor from '@/components/Ckeditor'
import { SweetModal } from 'sweet-modal-vue'
import DoctorMixin from './mixin'

export default {
  name: 'DoctorEditStep5',
  mixins: [DoctorMixin],
  components: {
    Step,
    DoctorArrayInput,
    Ckeditor,
    SweetModal,
    Multiselect
  },
  data () {
    return {
      doctor: {
        th: {
          info: '',
          video_links: []
        },
        en: {
          info: ''
        }
      },
      selected_languages: [],
      language_list: [],
      contentEng: '',
      contentThai: '',
      ckeditorConfig: {
        readOnly: !this.$guser.isActive(),
        toolbar: [
          { name: 'basicstyles', items: ['Bold', 'Italic'] },
          { name: 'paragraph', items: ['BulletedList'] },
          { name: 'styles', items: ['Format'] }
        ]
      },
      editMode: false
    }
  },
  computed: {
    isActive () {
      return this.$guser.user.clinic && this.$guser.user.clinic.active === 1
    }
  },
  methods: {
    back () {
      router.go(-1)
    },
    saveAndContinue () {
      var self = this

      let routeData = { path: this.next_uri(0), query: {action: this.$route.query.action} }

      // duplicate vid links
      self.doctor.en.video_links = self.doctor.th.video_links
      this.$http.put(this.doctor_uri,
        // data
        {
          languages: this.selected_languages.map(l => { return l.value }),
          en: self.doctor.en,
          th: self.doctor.th
        }).then(res => {
          if (res.body.status === 'success') {
            let backToMainDelay = 2000
            self.$refs.modal.open()
            if (self.$guser.isClinic()) {
              setTimeout(() => {
                self.$refs.modal.close()
                router.push({path: '/clinic/doctors'})
              }, backToMainDelay)
            } else {
              setTimeout(() => {
                self.$refs.modal.close()
                router.push(routeData)
              }, backToMainDelay)
            }
          }
        })
    },
    async deleteDoctor () {
      if (await this.$confirm(this.$t('action_message.are_you_sure'))) {
        this.$http.delete(this.$APP_CONFIG.api.admin.doctors_id(this.doctor.id)).then(res => {
          if (res.body) {
            router.push({path: '/clinic/doctors'})
          }
        })
      }
    },
    checkFeature (name) {
      if (!this.$guser.isActive()) {
        this.$refs.infoLockModal.open()
        return false
      }
      return true
    },
    gotoPlanPage () {
      this.$refs.infoLockModal.close()
      router.push({'path': '/package'})
    }
  },
  mounted () {
    this.editMode = this.$route.query.action === 'edit'

    var self = this
    // get languages
    this.$http.get(this.$APP_CONFIG.api.languages()).then(res => {
      self.language_list = res.body.map(l => {
        return {
          value: l.id,
          label: l.lang_name_en
        }
      })
    })

    // get doctor
    this.$http.get(this.doctor_uri).then(res => {
      self.doctor = Object.assign({}, res.body.data)
      if (self.doctor.th && !self.doctor.th.video_links) {
        self.doctor.th.video_links = []
      }

      // loaded selected languages
      self.selected_languages = self.doctor.languages.map(l => {
        return { value: l.id, label: l.name_en }
      })
    }, errorResponse => {
      console.error(errorResponse)
    })
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import "../../../assets/base_container";
.step-header {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.step-subheader{
  margin-bottom: 7px;
}
.step-container{
  h6{
    color: #5e5e5e;
    margin-bottom: 12px;
    font-size: 1.2rem;
  }
  .step-body{
    background-color: #fff;
    padding-top: 10px;
  }
}
.form-divider{
  height: 1px;
  border: 1px dashed #ddd;
  margin: 10px 0;
}
.gender-select{
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  margin-bottom: 1rem;
  .form-check{
    margin-bottom: 0px;
  }
  .form-check-inline + .form-check-inline{
    margin-left: 2.5rem;
  }
}
.editor-lock{
  position: absolute;
  font-size: 48px;
  top: 35%;
  left: 45%;
  color: #aaa;
}
</style>



// WEBPACK FOOTER //
// Info.vue?2691ad48